module.exports = __webpack_public_path__ + "img/10402cbae952c6c4e0a4b0c929f9524c.png";